import { useEffect, useState } from "react";
import FormField from "components/FormField";
import styles from "./Form.module.scss";
import Button, { SIZE } from "components/Button";
import classnames from "classnames";
import { useDispatch } from "react-redux";

import { login } from "actions/auth";
import ForgotPasswordPopup from "../ForgotPasswordPopup";

const Form = () => {
  const initialValues = {
    email: "",
    password: "",
  };
  const [formValues, setFormValues] = useState(initialValues);
  const [formErrors, setFormErrors] = useState({});
  const [submitted, setSubmitted] = useState(false);
  const [loading, setLoading] = useState(false);
  const [showPopup, setShowPopup] = useState(false);

  const dispatch = useDispatch();

  const handleChange = (e) => {
    const { name, value } = e.target;

    setFormValues({ ...formValues, [name]: value });
    setFormErrors({});
    setSubmitted(false);
    setLoading(false);
  };

  const validate = (values) => {
    let errors = {};

    const regex =
      /^(([^<>()\\[\]\\.,;:\s@"]+(\.[^<>()\\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;

    if (!values.email && !values.password) {
      errors.form = "These fields are required.";
    } else if (!values.email) {
      errors.email = "Email is required!";
    } else if (!regex.test(values.email)) {
      errors.email = "Please, enter a valid email";
    } else if (!values.password) {
      errors.password = "Password is required!";
    }

    return errors;
  };

  const handleOnSubmit = (e) => {
    e.preventDefault();

    setLoading(true);

    setFormErrors(validate(formValues));

    setSubmitted(true);
  };

  useEffect(() => {
    if (Object.keys(formErrors).length === 0 && submitted) {
      dispatch(login(formValues.email, formValues.password))
        .then(() => {
          window.location.reload();
        })
        .catch(() => {
          setFormErrors({ form: "No user with matching data found" });
          setLoading(false);
          setSubmitted(false);
        });
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [formErrors, submitted]);

  return !showPopup ? (
    <form
      className={styles.container}
      method="POST"
      action="submit"
      onSubmit={handleOnSubmit}
    >
      <h2 className={styles.title}>Login to account</h2>
      <FormField
        fieldName="email"
        labelText="Email"
        value={formValues.email}
        onChange={handleChange}
        className={styles.input}
        error={formErrors.email || formErrors.form}
      />
      <FormField
        type="password"
        fieldName="password"
        labelText="Password"
        value={formValues.password}
        onChange={handleChange}
        className={styles.input}
        error={formErrors.password || formErrors.form}
      />
      <p
        className={classnames(
          styles.error_message,
          formErrors.length !== 0 && styles.active,
        )}
      >
        {formErrors.form || formErrors.email || formErrors.password}
      </p>

      <Button
        type="submit"
        size={SIZE.LARGE}
        className={styles.button}
        disabled={loading}
      >
        Login
      </Button>

      <button
        className={classnames("link", styles.link)}
        onClick={() => setShowPopup(true)}
      >
        Forgot Password?
      </button>
    </form>
  ) : (
    <ForgotPasswordPopup setShowPopup={setShowPopup} />
  );
};

export default Form;
